
import React, { Component } from 'react';
import Slider from 'react-slick';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={ className }
            style={ { ...style, display: "block", background: "#e6e6e6" } }
            onClick={ onClick }
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={ className }
            style={ { ...style, display: "block", background: "#e6e6e6" } }
            onClick={ onClick }
        />
    );
}

class BannerSlider extends Component {

    handleClick = () => {
        const { handleImageClick } = this.props;
        handleImageClick && handleImageClick();
    }

    render() {
        const images = this.props.images;
        if (!images) {
            return <div></div>;
        }
        const imgs = images.map((img, idx) => {
            const thumbnail = img.thumbnail ? img.thumbnail : img.full;
            if (!thumbnail) {
                return <div key={ idx }></div>
            }
            const { url, format } = thumbnail;
            let media;
            if (format == 'mp4') {
                media = <video className='img-thumbnail' src={ url } autoPlay controls />;
            } else {
                media = <img className='product-img img-fluid' src={ url } alt='thumbnail' />;
            }
            return (
                <div className='d-flex justify-content-center align-content-end' key={ idx } onClick={this.handleClick}>
                    { media }
                </div>
            );
        });

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: false,
            infinite: true,
            arrows: true,

            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };

        return (
            <div className='mb-5 container'>
                <Slider { ...settings }{ ...this.props }>
                    { imgs }
                </Slider>
            </div>
        );
    }
}

export default BannerSlider;
